import React from 'react'

function ExploreBanner() {
  return (
    <div>
      <div className="page-banner change-name">
        <div className="container">
            <div className="row">
                <div className="col-lg-6 offset-lg-3">
                    <div className="header-text">
                        <h2><em>Explore</em> Our Work</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod keoi tempor incididunt ut labore et dolore magna aliqua.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
  )
}

export default ExploreBanner
